import { render } from "./DeleteInsightsModal.vue?vue&type=template&id=52e518e0"
import script from "./DeleteInsightsModal.vue?vue&type=script&lang=js"
export * from "./DeleteInsightsModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/popinsight-tools/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__